import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';
import {MatPaginatorModule, MatPaginatorIntl} from '@angular/material';
import { MatPaginatorIntlBr} from './mat-custom-paginator';

import { CommonModule } from '@angular/common';
import { MatSelectYearComponent } from './mat-select-year';
import { MatSelectMonthComponent } from './mat-select-month';
import { MatSelectFilialComponent } from './mat-select-filial';
import { MatDataGridModule } from './mat-datagrid-module';
import { MatTableGridComponent,MatTableGridDialog } from './mat-tablegrid';
import { MatDataNavigationComponent } from './mat-data-navigation';
import { MatContainerModule } from './mat-container';
import { MatVertGrid } from './mat-vert-grid';

@NgModule({
  imports: [
    MatContainerModule,
    CommonModule,
    FormsModule,
    MaterialModule,
    MatDataGridModule
  ],
  declarations: [
    MatSelectYearComponent,
    MatSelectMonthComponent,
    MatSelectFilialComponent,
    MatTableGridComponent,
    MatDataNavigationComponent,
    MatTableGridDialog,
    MatVertGrid,

  ],
  exports: [
    MatSelectYearComponent,
    MatSelectMonthComponent,
    MatSelectFilialComponent,
    MatTableGridComponent,
    MatDataNavigationComponent,
  ],
  entryComponents:[MatTableGridDialog],
  providers: [{ provide: MatPaginatorIntl, useClass: MatPaginatorIntlBr}],

})
export class ControlsModule { }
